// eslint-disable-next-line
/* global __DEV__ */

/**
 * The options used to configure the API.
 */
export interface ApiConfig {
  /**
   * The URL of the api.
   */
  url: string

  /**
   * Milliseconds before we timeout the request.
   */
  timeout: number
}

/**
 * The default configuration for the app.
 */
export const DEFAULT_API_CONFIG: ApiConfig = {
  url: process.env.REACT_APP_API_URL || 'https://api.prod.trivie.com',
  timeout: 120000,
}
